import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

  .static-page {
    font-family: 'Inter', system-ui, sans-serif;
    background: #0a0f1e;
    min-height: 100vh;
    color: #e2e8f0;
  }

  .static-hero {
    background: linear-gradient(160deg, #0f172a 0%, #1e1b4b 50%, #0a0f1e 100%);
    padding: 80px 24px 70px;
    text-align: center;
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid rgba(99,102,241,0.15);
  }

  .static-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 70% 60% at 50% -10%, rgba(99,102,241,0.18) 0%, transparent 70%);
    pointer-events: none;
  }

  .static-label {
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #a5b4fc;
    background: rgba(99,102,241,0.1);
    border: 1px solid rgba(99,102,241,0.25);
    border-radius: 100px;
    padding: 4px 14px;
    margin-bottom: 20px;
  }

  .static-hero h1 {
    font-size: clamp(2rem, 5vw, 3.2rem);
    font-weight: 900;
    color: #f1f5f9;
    margin: 0 0 16px;
    letter-spacing: -0.03em;
  }

  .static-hero h1 span {
    background: linear-gradient(135deg, #818cf8, #6366f1);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .static-hero-sub {
    font-size: 1.05rem;
    color: #64748b;
    max-width: 540px;
    margin: 0 auto;
    line-height: 1.7;
  }

  .static-body {
    max-width: 800px;
    margin: 0 auto;
    padding: 64px 24px 100px;
  }

  /* Contact channels grid */
  .channels-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 40px;
  }

  @media (max-width: 640px) {
    .channels-grid { grid-template-columns: 1fr; }
  }

  .channel-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(99,102,241,0.14);
    border-radius: 18px;
    padding: 28px 20px;
    text-align: center;
    transition: all 0.25s;
  }

  .channel-card:hover {
    border-color: rgba(99,102,241,0.3);
    background: rgba(99,102,241,0.06);
    transform: translateY(-2px);
  }

  .channel-icon {
    font-size: 2rem;
    margin-bottom: 12px;
  }

  .channel-title {
    font-size: 0.9rem;
    font-weight: 700;
    color: #e2e8f0;
    margin-bottom: 4px;
  }

  .channel-email {
    font-size: 0.82rem;
    color: #a5b4fc;
    text-decoration: none;
    font-weight: 500;
  }

  .channel-email:hover { text-decoration: underline; }

  .channel-response {
    font-size: 0.78rem;
    color: #475569;
    margin-top: 6px;
  }

  /* Form */
  .contact-form-wrap {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(99,102,241,0.14);
    border-radius: 20px;
    padding: 40px;
    margin-bottom: 28px;
  }

  .contact-form-wrap h2 {
    font-size: 1.2rem;
    font-weight: 800;
    color: #f1f5f9;
    margin: 0 0 24px;
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }

  @media (max-width: 560px) {
    .form-grid { grid-template-columns: 1fr; }
    .contact-form-wrap { padding: 28px 20px; }
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 16px;
  }

  .form-group label {
    font-size: 13px;
    font-weight: 600;
    color: #94a3b8;
  }

  .form-group input,
  .form-group textarea,
  .form-group select {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(99,102,241,0.2);
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    color: #e2e8f0;
    font-family: inherit;
    outline: none;
    transition: border-color 0.2s, background 0.2s;
    resize: vertical;
  }

  .form-group input::placeholder,
  .form-group textarea::placeholder {
    color: #334155;
  }

  .form-group input:focus,
  .form-group textarea:focus,
  .form-group select:focus {
    border-color: rgba(99,102,241,0.5);
    background: rgba(99,102,241,0.06);
  }

  .form-group select option {
    background: #1e1b4b;
    color: #e2e8f0;
  }

  .btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #6366f1, #4f46e5);
    color: white;
    text-decoration: none;
    padding: 14px 32px;
    border-radius: 12px;
    font-size: 0.95rem;
    font-weight: 700;
    transition: all 0.2s;
    box-shadow: 0 4px 20px rgba(99,102,241,0.35);
    font-family: inherit;
    border: none;
    cursor: pointer;
    width: 100%;
    justify-content: center;
  }

  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 32px rgba(99,102,241,0.55);
  }

  .btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  /* Success state */
  .form-success {
    text-align: center;
    padding: 40px 20px;
  }

  .form-success-icon {
    font-size: 3rem;
    margin-bottom: 16px;
  }

  .form-success h3 {
    font-size: 1.3rem;
    font-weight: 800;
    color: #f1f5f9;
    margin-bottom: 8px;
  }

  .form-success p {
    color: #64748b;
    font-size: 0.95rem;
  }

  /* FAQ */
  .faq-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(99,102,241,0.12);
    border-radius: 20px;
    padding: 40px;
  }

  .faq-card h2 {
    font-size: 1.15rem;
    font-weight: 800;
    color: #f1f5f9;
    margin: 0 0 24px;
  }

  .faq-item {
    border-bottom: 1px solid rgba(99,102,241,0.1);
    padding: 16px 0;
  }

  .faq-item:last-child { border-bottom: none; }

  .faq-q {
    font-size: 0.93rem;
    font-weight: 700;
    color: #c7d2fe;
    margin-bottom: 8px;
  }

  .faq-a {
    font-size: 0.9rem;
    color: #64748b;
    line-height: 1.7;
  }
`;

const FAQS = [
  {
    q: 'How quickly will I get a response?',
    a: 'General support and questions: within 24 hours. Bug reports: within 12 hours. Business inquiries: within 48 hours.',
  },
  {
    q: 'Can I report a malicious link?',
    a: 'Yes — email us at admin@rdrto.com with the RDRTO short link you want to report. We investigate all abuse reports within 12 hours.',
  },
  {
    q: 'Where can I find documentation?',
    a: 'API documentation and feature guides are available from your dashboard. For anything not covered, email us.',
  },
  {
    q: 'Do you offer custom enterprise plans?',
    a: 'Yes — if you need volume discounts, SLAs, or custom integrations, reach out via the business enquiries email and we\'ll chat.',
  },
];

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: 'general', message: '' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setSending(true);
    setError('');

    try {
      const response = await axios.post(`${API_BASE_URL}/api/contact`, form);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send message. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="static-page">
      <style>{STYLES}</style>

      <div className="static-hero">
        <span className="static-label">Support</span>
        <h1>We're here to <span>help</span></h1>
        <p className="static-hero-sub">
          Questions, bug reports, or business inquiries — pick a channel below or send us a message directly.
        </p>
      </div>

      <div className="static-body">

        {/* Channel cards */}
        <div className="channels-grid">
          <div className="channel-card">
            <div className="channel-icon">📧</div>
            <div className="channel-title">General Support</div>
            <a className="channel-email" href="mailto:admin@rdrto.com">admin@rdrto.com</a>
            <div className="channel-response">Responds within 24 hrs</div>
          </div>
          <div className="channel-card">
            <div className="channel-icon">🐛</div>
            <div className="channel-title">Bug Reports</div>
            <a className="channel-email" href="mailto:admin@rdrto.com">admin@rdrto.com</a>
            <div className="channel-response">Responds within 12 hrs</div>
          </div>
          <div className="channel-card">
            <div className="channel-icon">💼</div>
            <div className="channel-title">Business Enquiries</div>
            <a className="channel-email" href="mailto:admin@rdrto.com">admin@rdrto.com</a>
            <div className="channel-response">Responds within 48 hrs</div>
          </div>
        </div>

        {/* Contact form */}
        <div className="contact-form-wrap">
          {sent ? (
            <div className="form-success">
              <div className="form-success-icon">✅</div>
              <h3>Message received!</h3>
              <p>Thanks for reaching out. We'll get back to you at <strong style={{ color: '#a5b4fc' }}>{form.email}</strong> within 24 hours.</p>
            </div>
          ) : (
            <>
              <h2>Send us a message</h2>
              {error && (
                <div style={{
                  background: 'rgba(239, 68, 68, 0.1)',
                  border: '1px solid rgba(239, 68, 68, 0.2)',
                  color: '#fca5a5',
                  padding: '12px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  fontSize: '14px'
                }}>
                  ⚠️ {error}
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="cnt-name">Your Name</label>
                    <input
                      id="cnt-name"
                      name="name"
                      type="text"
                      placeholder="Jane Smith"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="cnt-email">Email Address</label>
                    <input
                      id="cnt-email"
                      name="email"
                      type="email"
                      placeholder="jane@example.com"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="cnt-subject">Subject</label>
                  <select
                    id="cnt-subject"
                    name="subject"
                    value={form.subject}
                    onChange={handleChange}
                  >
                    <option value="general">General Question</option>
                    <option value="bug">Bug Report</option>
                    <option value="billing">Billing & Plans</option>
                    <option value="abuse">Report Abuse / Malicious Link</option>
                    <option value="business">Business Enquiry</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="cnt-message">Message</label>
                  <textarea
                    id="cnt-message"
                    name="message"
                    rows={5}
                    placeholder="Describe your question or issue..."
                    value={form.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button type="submit" className="btn-primary" disabled={sending}>
                  {sending ? 'Sending…' : '✉️ Send Message'}
                </button>
              </form>
            </>
          )}
        </div>

        {/* FAQ */}
        <div className="faq-card">
          <h2>Frequently Asked Questions</h2>
          {FAQS.map((faq, i) => (
            <div className="faq-item" key={i}>
              <div className="faq-q">{faq.q}</div>
              <div className="faq-a">{faq.a}</div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Contact;
